import React, { useState, useEffect } from 'react';

const TimerQuiz = ({ timeLimit, onTimeUp, updateTimeLeft }) => {
  const [timeLeft, setTimeLeft] = useState(timeLimit);

  // useEffect(() => {
  //   setTimeLeft(timeLimit);
  // }, [])

  useEffect(() => {
     // Reset timer whenever the component is re-rendered with a new question

    const timer = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          onTimeUp(); // Notify parent component that time is up
        }
        return prev - 1;
      });


    }, 1000);

    return () => clearInterval(timer); // Clean up the timer on component unmount
  }, [onTimeUp]);

  useEffect(() => {
    updateTimeLeft(timeLeft);
  }, [timeLeft])

  return (
    <div className="mb-2">
      <div className="text-lg font-bold text-red-600">
        {`Time Left: ${String(Math.floor(timeLeft / 60)).padStart(2, '0')}:${String(timeLeft % 60).padStart(2, '0')}`}
      </div>
    </div>
  );
};

export default TimerQuiz;
